module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_01-1d03d4317a47710c3bc6d77d2167c9cd.png";